/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_TitleInputs */

const en_shop_title = /** @type {(inputs: Shop_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shop`)
};

const pl_shop_title = /** @type {(inputs: Shop_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sklep`)
};

/**
* | output |
* | --- |
* | "Shop" |
*
* @param {Shop_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const shop_title = /** @type {((inputs?: Shop_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_shop_title(inputs)
	return en_shop_title(inputs)
});